export default __webpack_public_path__ + "static/media/visa.f7a05a2e.svg";